import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useUrlFromHandle } from '../../contexts/RoutesContext';
import ArticlesList from '../lists/ArticlesList';

import styles from '../../../styles/blocks/articles.module.scss';

const propTypes = {
    title: PropTypes.string,
    query: PropTypes.shape({}),
    layout: PropTypes.string,
    withDetails: PropTypes.bool,
    isContainer: PropTypes.bool,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    query: null,
    layout: null,
    withDetails: false,
    isContainer: false,
    className: null,
    containerClassName: null,
};

const ArticlesBlock = ({
    title,
    query,
    layout,
    withDetails,
    isContainer,
    className,
    containerClassName,
}) => {
    const handle = useUrlFromHandle();
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles[layout]]: layout !== null,
                [className]: className !== null,
            })}
        >
            <div
                className={classNames([
                    'blockEvents',
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <ArticlesList
                    listClassName={styles.list}
                    title={title}
                    query={query}
                    withoutColumns={layout !== 'grid'}
                    cardType={withDetails ? 'article' : 'shortcut'}
                    cardProps={{ isDark: true }}
                    link={{
                        href: handle('articles'),
                        label: (
                            <FormattedMessage
                                defaultMessage="View all articles"
                                description="Button label"
                            />
                        ),
                    }}
                />
            </div>
        </div>
    );
};

ArticlesBlock.propTypes = propTypes;
ArticlesBlock.defaultProps = defaultProps;

export default ArticlesBlock;
